import React from 'react';

import { Skeleton } from '@/components/ui/skeleton';

import {
  DEFAULT_STORE_TAB_SKELETON_SLOT_COUNT,
  STORE_TAB_SKELETON_TEST_IDS,
} from './StoreTabSkeleton.consts';

const SKELETON_ITEM_CLASS = 'w-full rounded-[20px] bg-white/10';

export const StoreTabSkeleton = (): React.ReactElement => {
  const slots = Array.from(
    { length: DEFAULT_STORE_TAB_SKELETON_SLOT_COUNT },
    (_, index) => index
  );

  return (
    <div
      className="flex min-h-[50vh] w-full flex-1 justify-center px-[18px] md:px-0"
      data-testid={STORE_TAB_SKELETON_TEST_IDS.root}
      aria-busy="true"
      aria-label="Loading store"
    >
      <div className="flex w-[60%] max-w-full flex-col gap-5 md:gap-[22px]">
        <Skeleton
          data-testid={STORE_TAB_SKELETON_TEST_IDS.header}
          className={`${SKELETON_ITEM_CLASS} h-12`}
        />
        {slots.map((index) => (
          <Skeleton
            key={index}
            data-testid={`${STORE_TAB_SKELETON_TEST_IDS.slot}-${index}`}
            className={`${SKELETON_ITEM_CLASS} h-[120px]`}
          />
        ))}
        <Skeleton
          data-testid={STORE_TAB_SKELETON_TEST_IDS.footer}
          className={`${SKELETON_ITEM_CLASS} h-9`}
        />
      </div>
    </div>
  );
};
